<div class="status-tracker-container"
  [ngClass]="{'progress-ar': _translate.currentLang === 'ar', 'progress-en': _translate.currentLang === 'en'}">
  <button mat-raised-button class="status-button">
    <ng-container *ngIf="_translate.currentLang === 'ar'">{{currentStatus.nameAr}}</ng-container>
    <ng-container *ngIf="_translate.currentLang === 'en'">{{currentStatus.nameEn}}</ng-container>
  </button>
</div>